import DashboardListView from '../dashboardListView';

export function DashboardListController({
  listModeActive,
}: {
  listModeActive: boolean;
}) {
  return <DashboardListView listModeActive={listModeActive} />;
}
